import { IndexExpense } from "../../index-expense";

export class updateExpense {
    dataId: IndexExpense;
    add_comapin: boolean;
    constructor (dataId,add_comapin) {
        this.dataId = dataId;
        this.add_comapin = add_comapin;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/info-expense/update-expense.ts